// extracted by mini-css-extract-plugin
export default {"root":"L_uG3wGHIC"};